<div class="flex items-center" mat-dialog-title>
    <h2 class="headline m-0 flex-auto">{{data.title}}</h2>
    <button class="text-secondary" mat-dialog-close mat-icon-button type="button">
        <mat-icon svgIcon="mat:close"></mat-icon>
    </button>
</div>
<mat-divider class="text-border"></mat-divider>
<mat-dialog-content class="flex flex-col">
    
    <img [src]="foto()" class="rounded w-full" alt="Sin Foto">

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close type="button">{{appSettings.DIALOG_BUTTON_CANCEL}}</button>
    <!-- <button [disabled]="form.invalid" color="primary" mat-flat-button type="submit">{{data.button}}</button> -->
    <!-- <button [disabled]="form.invalid" color="primary" mat-flat-button>{{data.button}}</button> -->
</mat-dialog-actions>